import {PageResponseTag} from '@shipwell/corrogo-sdk';
import {PaginationState} from '@tanstack/react-table';

export function getTotalPages(pagination: PaginationState, data?: PageResponseTag) {
  if (!data || !data.total_count) return 1;
  return Math.ceil(data.total_count / pagination.pageSize);
}
